<script>
  import Emitter from '../../../../assets/js/mixins/emitter';

  export default {
    name: 'poi-checkbox-group',

    componentName: 'poi-checkbox-group',

    mixins: [Emitter],

    inject: {
      elFormItem: {
        default: ''
      }
    },

    props: {
      value: {},
      disabled: Boolean,
      min: Number,
      max: Number,
      size: String,
      fill: String,
      textColor: String
    },

    computed: {
      checkboxGroupSize() {
        return this.size;
      }
    },

    watch: {
    }
  };
</script>

<template>
  <div class="poi-checkbox-group" role="group" aria-label="checkbox-group">
    <slot></slot>
  </div>
</template>
